import React from 'react';
import { ExternalLink } from 'lucide-react';
import SectionUnlock from '../components/SectionUnlock';

const TestimonialsSection = ({ unlockedSections }) => {
  return (
    <section id="testimonials" className="py-20 bg-gray-50 relative">
      <SectionUnlock sectionId="testimonials" unlockedSections={unlockedSections}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Testimonial</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              What others say about my work and dedication
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-blue-200 transition-colors">
                  <span className="text-blue-600 text-2xl">💬</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">Recommendation</h3>
                  <p className="text-gray-600">Click to view my detailed testimonial letter</p>
                </div>
              </div>
              
              <div className="bg-white p-6 rounded-lg border border-blue-200 shadow-sm">
                <blockquote className="text-gray-700 italic text-lg leading-relaxed mb-4">
                  "This testimonial showcases my growth, technical skills and collaborative approach to problem-solving"
                </blockquote>
                
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-600">
                    <p className="font-semibold">Professional Reference</p>
                    <p>Mentor</p>
                  </div>
                  
                  <a 
                    href="https://drive.google.com/file/d/1DKMDpsHQw08etcLYER36O_utTsyIisps/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
                  >
                    <ExternalLink size={16} />
                    View Full Testimonial
                  </a>
                </div>
              </div>
              
              <div className="mt-4 flex items-center gap-2 text-sm text-gray-500">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                Verified testimonial
              </div>
            </div>
          </div>
        </div>
      </SectionUnlock>
    </section>
  );
};

export default TestimonialsSection;